module.exports = __webpack_public_path__ + "img/icon-caution.0343b7f0.svg";